import React,{useState,useEffect} from 'react'
import ScDesigner from './scDesigner/ScDesigner'
import { useParams } from 'react-router-dom'
import Loading from '../common/Loading'
import surveyService from '../../services/survey.service'
import { useEyeconxStore } from '../../store/eyeconxStore'

function SurveyEdit() {
  const {setSurvey,resetSurvey} = useEyeconxStore()
  const {surveyId} = useParams()
  const adminClinicId = useEyeconxStore((state)=>state.user.clinicId)
  const [loading,setLoading] = useState(false)
  useEffect(()=>{
    console.log("Edit Survey")
    resetSurvey()
    getSurveyInfo()
   

  },[surveyId,adminClinicId])  

  const getSurveyInfo = ()=>{
    setLoading(true)
    console.log("getting survey Info")
    surveyService.getEcxSurveyById(adminClinicId,surveyId)
    .then(res=>{
       console.log(res.data)
       console.log("data values")
       console.log(res.data.data)
       setSurvey(res.data)
       setLoading(false)
    })
    .catch(err=>{
      console.log(err)
      setLoading(false)
    })
  }
  return (
    <>
    {loading ? <Loading/>:
       <ScDesigner />}
    </>
  )
}

export default SurveyEdit